<template>
    <div class="ContenedorMarcadorResultados Visible" v-if="BaseFirebaseOk">
      {{MiNombre}} <b>{{Ganadas()}}</b>  -  <b>{{Perdidas()}}</b> Others

      <div class="ContenedorPanel">
          <div class="ContenedorTitulo">Edit Score</div>
          <div class="ContenedorBotones">
            <div class="BotonesLeft">
                <div class="Boton BotonRojo noselect" @click="RestarWin()">&#8595;</div> <div class="Boton BotonVerde noselect" @click="SumarWin()">&#8593;</div> 
            </div>
            <div class="BotonReset noselect" @click="ResetearMarcador()" title="It save the current score">Reset</div>
            <div class="BotonesRight">
                <div class="Boton BotonRojo noselect" @click="RestarLose()">&#8595;</div> <div class="Boton BotonVerde noselect" @click="SumarLose()">&#8593;</div> 
            </div>
          </div>
      </div>
    </div>
</template>

<script>
    import Firebase from 'firebase/app';
    import 'firebase/database';
    import 'firebase/analytics';
    import Config1 from "../ConfigAoe2DE-Auth";

    let app = Firebase.initializeApp(Config1);
    Firebase.analytics();
    let db = app.database();
    let MarcadorResultadosRef = db.ref("MarcadorResultados");
    import Utilities from "../Utilities/Utilities.js";
    export default {
        name:"MarcadorResultadosFB",
        firebase: {
            MarcadorResultados: MarcadorResultadosRef
        },
        props:{
            //Solo1v1: Boolean
        },
        data(){
            return {
                MiNombre: "TM Marty",
                DatosMarcador: {
                    Ganadas:0,
                    Perdidas:0
                },
                ProfileId: "945834",
                InfoFB: null,
                BaseFirebaseOk: false,
            }
        },
        async mounted(){
            console.log("asdasd");
            // fetch('https://api.ipify.org?format=json', function(data){
            //     console.log(data);
            //     console.log(data.ip);
            // });
            // fetch('https://api.ipify.org?format=json')
            // // fetch('http://ip-api.com/json')
            // .then(r => r.json())
            // .then(json => {
            //     console.log(json);
            //     console.log(json.ip);
            // });
            //console.log(this.ObtenerResultados());
            this.InfoFB = await this.ObtenerInfoDeUnProfile(this.ProfileId);
            if (this.InfoFB == null){
                await MarcadorResultadosRef.push(new Marcador(this.ProfileId));
                this.InfoFB = await this.ObtenerInfoDeUnProfile(this.ProfileId);
            }

            if (this.InfoFB == null){
                console.log("VER");
                return;
            }

            //Creo el evento para cuando se actualiza algun dato de la base
            var _DataUser = db.ref("MarcadorResultados/" + this.InfoFB.key);
            _DataUser.on('value', (snapshot) => {
                const data = snapshot.val();
                this.InfoFB._Registros = data._Registros;
                //console.log("Registros actualizados", data._Registros);
            });
            this.BaseFirebaseOk = true;

        },
        methods: {
            async ActualizarRegistrosEnFirebase(){
                try {
                    var _This = this;
                    await db.ref("MarcadorResultados/" + _This.InfoFB.key)
                    .update({ _Registros: _This.InfoFB._Registros })
                    .then(() => { 
                        //console.log('Registro updated!') 
                    });
                } catch (e) {
                    console.log(e);
                }
            },
            async ObtenerInfoDeUnProfile(ProfileId){
                var _Retorno = null;
                try {
                    await MarcadorResultadosRef.once('value', function(info) {
                        info.forEach(function(Resultado) {
                            if(Resultado.val()._ProfileId == ProfileId){
                                _Retorno = Resultado.val();
                                _Retorno.key = Resultado.key;
                            }
                        });
                    });
                } catch (e) {
                    console.log(e);
                }
                return _Retorno;
            },
            SumarWin(){
                var _ResAux = this.InfoFB._Registros[this.InfoFB._Registros.length - 1];
                _ResAux._Ganadas += 1;
                this.ActualizarRegistrosEnFirebase();
            },
            RestarWin(){
                var _ResAux = this.InfoFB._Registros[this.InfoFB._Registros.length - 1];
                if(_ResAux._Ganadas > 0){
                    _ResAux._Ganadas -= 1;
                    this.ActualizarRegistrosEnFirebase();
                }
            },
            SumarLose(){
                var _ResAux = this.InfoFB._Registros[this.InfoFB._Registros.length - 1];
                _ResAux._Perdidas += 1;
                this.ActualizarRegistrosEnFirebase();
            },
            RestarLose(){
                var _ResAux = this.InfoFB._Registros[this.InfoFB._Registros.length - 1];
                if(_ResAux._Perdidas > 0){
                    _ResAux._Perdidas -= 1;
                    this.ActualizarRegistrosEnFirebase();
                }
            },
            ResetearMarcador(){
                this.InfoFB._Registros.push(new RegistroMarcador());
                this.ActualizarRegistrosEnFirebase();
            },
            Ganadas(){
                return this.InfoFB._Registros[this.InfoFB._Registros.length - 1]._Ganadas;
            },
            Perdidas(){
                return this.InfoFB._Registros[this.InfoFB._Registros.length - 1]._Perdidas;
            }
        }
    }

    class Marcador{
        constructor(_ProfileId){
            this._ProfileId = _ProfileId;
            this._Registros = [];
            this._Registros.push(new RegistroMarcador());
        }
    }
    class RegistroMarcador {
        constructor() {
            this._Ganadas = 0;
            this._Perdidas = 0;
            this._Fecha = new Fecha();
        }
    };
    class Fecha {
        constructor(_Fecha) {
        if (!_Fecha){
            _Fecha = new Date();
        }
        this._Año = _Fecha.getFullYear();
        this._Mes = _Fecha.getMonth() + 1;
        this._Dia = _Fecha.getDate();
        this._Horas = _Fecha.getHours();
        this._Minutos = _Fecha.getMinutes();
        this._Segundos = _Fecha.getSeconds();
        this._FechaYHora = this.ObtenerTexto();
        this._Fecha = this.ObtenerTexto1();
        }
        ObtenerTexto(){
        var _Retorno = "";
        try {
            _Retorno += ("0" + this._Dia).slice(-2);
            _Retorno += "/" + ("0" + this._Mes).slice(-2);
            _Retorno += "/" + this._Año;
            _Retorno += " " + ("0" + this._Horas).slice(-2);
            _Retorno += ":" + ("0" + this._Minutos).slice(-2);
            _Retorno += ":" + ("0" + this._Segundos).slice(-2);
        } catch (error) {
            console.log(error);
        }
        return _Retorno;
        }
        ObtenerTexto1(){
        var _Retorno = "";
        try {
            _Retorno += ("0" + this._Dia).slice(-2);
            _Retorno += "/" + ("0" + this._Mes).slice(-2);
            _Retorno += "/" + this._Año;
        } catch (error) {
            console.log(error);
        }
        return _Retorno;
        }
        Paquete(){
        return (this._Año + "/" + this._Mes + "/" + this._Dia + "/" + this._Horas + "/" + this._Minutos + "/" + this._Segundos);
        }
        SetearDesdePaquete(_Paquete){
        var _Aux = _Paquete.split("/");
        if (_Aux.length != 6){
            return;
        }
        this._Año = _Aux[0];
        this._Mes = _Aux[1];
        this._Dia = _Aux[2];
        this._Horas = _Aux[3];
        this._Minutos = _Aux[4];
        this._Segundos = _Aux[5];
    
        this._FechaYHora = this.ObtenerTexto();
        this._Fecha = this.ObtenerTexto1();
        }
        ObtenerFecha(){
            var _Retorno = new Date(Date.UTC(this._Año, this._Mes - 1, this._Dia, this._Horas, this._Minutos, this._Segundos));
            return _Retorno;
        }
    };
</script>

<style scoped lang="scss">
    .ContenedorMarcadorResultados{
        position:absolute;
        bottom:-115px;
        height:50px;
        line-height:42px;
        font-size:38px;
        padding:10px 40px;
        width:fit-content;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: green;
        border-radius:0 0 40px 40px;
        background-image: url("../assets/hex.png");
        background-repeat: repeat;
        box-shadow:inset 0 0 20px #000;
        border:4px solid #000;
        opacity: 0;
        transition: all 1s;
    }
    .Visible{
        opacity: 1;
    }
    .ContenedorPanel{
        position:relative;
        width: 100%;
        //   height:50px;
        //   line-height:50px;
        margin-top:100px;
        background-color: #000;
            color:#CCC;
    }
    .ContenedorTitulo{
            width:100%;
            // height: 30px;
            line-height: 30px;
            // font-size:22px;
            border:1px solid #AAA;
            border-bottom:none;
            box-sizing: border-box;
            padding:10px 0;
    }
    .ContenedorBotones{
            display:flex;
            align-content: space-between;
            border:1px solid #AAA;
            padding:5px 0;
    }
    .BotonesLeft{
            width:50%;
            box-sizing: border-box;
            padding:2px 10px;
            display: flex;
        }
    .BotonesRight{
            width:50%;
            box-sizing: border-box;
            padding:2px 10px;
            display: flex;
            justify-content: flex-end;
        }
    .Boton{
        // width:50px;
        height: 50px;
        padding:0 15px;
        background-color:black;
        border-radius:50%;
        box-sizing: border-box;
        font-weight: bold;
        text-align: center;
        margin: 0 5px;
        cursor: pointer;
        outline: none;
    }
    .BotonVerde{
        color: #00D815;
        border:2px solid #00D815;
        &:hover{
            box-shadow: 0 0 10px #00D815;
        }
    }
    .BotonRojo{
        color: #FF0000;
        border:2px solid #FF0000;
        &:hover{
            box-shadow: 0 0 10px #FF0000;
        }
    }
    .BotonReset{
        cursor: pointer;
        font-size:30px;
        &:hover{
            text-decoration: underline;
        }
    }

</style>